import React, { useEffect } from "react";
import "./terms.scss";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
const AccountDeletion = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <Header />
            <section className="terms">
                <img src="\assets\career-bg.png" alt="img" className='img-fluid career-bg' />
                <div className="custom-container">
                    <div className="main-heading">
                        <h2 className="heads">Account Deletion</h2>
                    </div>
                    <div className="maincontent">
                        <p className="main-text">Account Deletion – Queen Wars: Chess Royale</p>
                        <p className="date-text">Last Updated: January 8, 2026</p>
                        <p className="para">
                            Users of the mobile game “Queen Wars: Chess Royale”
                            (Android package name: com.leia.queenwars) may request
                            deletion of their account and associated personal data at any time.
                        </p>






                        <h2 className="headsinner">How to Request Account Deletion:</h2>
                        <p className="para">To delete your account, please send an email to <a href="mailto: support@queenwars.io">support@queenwars.io</a>
                            from the email address associated with your Queen Wars account,
                            using the subject line: “Account Deletion Request”.</p>
                        <h3>Data Deleted:</h3>
                        <p className="para">Upon verification, the following data will be permanently deleted:</p>

                        <ul>
                            <li>Account profile</li>
                            <li>Gameplay history</li>
                            <li>Rankings and progression data</li>
                            <li>Stored preferences</li>
                        </ul>
                        <h3>Deletion Timeframe:</h3>
                        <p className="para">
                            Account deletion requests are processed within 7 days. <br />
                            Some data may be retained if required by law or for fraud prevention.
                        </p>




                    </div>
                </div>

            </section>
            <Footer />
        </>
    );
};

export default AccountDeletion;
